<template>
<div>
    <div class="card">
        <div class="card-body p-5">
            <form @submit.prevent="submitInfo">
                <div class="form-group">
                    <label class="form-label">{{$t('label.location')}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fas fa-map-marker-alt"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.location')" v-model="dataLocation">
                    </div>
                </div>
                <div class="border-bottom mt-5 mb-3">
                    <h4>{{$t('header.address')}}</h4>
                </div>
                <div class="form-group" v-for="(add, index) in address" :key="index">
                    <label class="form-label">{{$t('label.address')}} {{index + 1}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fas fa-map-marker-alt"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.address') + (index + 1)" v-model="addr[index]">
                    </div>
                </div>
                <div class="border-bottom mt-5 mb-3">
                    <h4>{{$t('header.business_hour')}}</h4>
                </div>
                <div class="row pb-5">
                    <div class="col-lg-6 col-xl-6">
                        <div class="form-group">
                            <label class="form-label">{{$t('label.start_time')}}</label>
                            <div class="input-group bg-white shadow-inset-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-clock"></i>
                                    </span>
                                </div>
                                <vue-timepicker class="form-control bg-transparent" format="H:00" hour-label="Hour" auto-scroll close-on-complete v-model="startTime"></vue-timepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6">
                        <div class="form-group">
                            <label class="form-label">{{$t('label.end_time')}}</label>
                            <div class="input-group bg-white shadow-inset-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-clock"></i>
                                    </span>
                                </div>
                                <vue-timepicker class="form-control bg-transparent" format="H:00" hour-label="Hour" auto-scroll close-on-complete v-model="endTime"></vue-timepicker>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">{{$t('outlet_setting.social_media.waze')}} ({{$t('label.recommend')}})</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fab fa-waze"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('outlet_setting.social_media.waze')" v-model="waze">
                    </div>
                </div>
                <div class="text-left border-top pt-3 mt-5">
                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.next')}}</button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>
<script>
import VueTimepicker from 'vue2-timepicker'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'setupInfo',
    props:{
        outletID: { type: Number },
        location: { type: String }
    },
    components: { VueTimepicker },
    data(){
        return{
            step: 1,
            address: [],
            dataLocation: this.location, startTime: "", endTime: "", waze: "",
            isError: false,
            booking: [], social: [],
        }
    },
    computed:{
        addr(){
            var ret = [];
            for(var i=0; i<this.address.length; i++){
                ret.push(this.address[i]);
            }
            return ret;
        },
    },
    methods:{
        closeModal(isError){
            this.$parent.$parent.isModalShow = false
        },
        getFormData(){
            let $vm = this
            const receiptURL = this.$api.OUTLET + "/" + this.outletID + this.$api.RECEIPT;
            $vm.$axios({
                method: 'get', 
                url: receiptURL,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                $vm.address = response.data.address;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();
                }
            })

            const bookingURL = this.$api.OUTLET + "/" + this.outletID + this.$api.BOOKING;
            $vm.$axios({
                method: 'get', 
                url: bookingURL,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                $vm.booking = response.data;       
                $vm.startTime = $vm.booking.hours[0] + ":00";
                $vm.endTime = $vm.booking.hours[$vm.booking.hours.length - 1] + 1 + ":00";
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();
                }
            })

            const socialURL = this.$api.OUTLET + "/" + this.outletID + this.$api.SOCIAL_MEDIA;
            $vm.$axios({
                method: 'get', 
                url: socialURL,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                for (var r in response.data){
                    if(r == "waze"){
                        $vm.waze = response.data[r];
                    }
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();
                }
            })
        },
        submitInfo(){
            var sTime = parseInt(this.startTime.split(":")[0]);
            var eTime = parseInt(this.endTime.split(":")[0] - 1);

            var hours = [];
            while(sTime<=eTime){
                hours.push(sTime);
                sTime++;
            }

            var data = {
                info: { location: this.dataLocation},
                receipt: { address: this.addr },
                book: { hours: hours,
                        msg: this.booking.msg },
                social: { waze: this.waze }
            }         

            let url = this.$api.OUTLET + "/" + this.outletID + "/";
            let $vm = this
            for(var d in data){
                $vm.$axios({
                    method: 'post', 
                    url: url + d,
                    baseURL: $vm.$axios.defaults.baseURL, 
                    headers: {token: $vm.$session.get('token')},
                    data: data[d],
                })
                .then((response) => {})
                .catch((err) => {
                    var errData = err.response.data;
                    if(errData.error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();  
                    }else{
                        $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                        $vm.isError = true
                        return false
                    }
                })
            }
            if(!this.isError){
                this.$emit('submitInfo', this.step);
            }
        },
    },
    mounted(){
        let $vm = this;
        $vm.getFormData()
    }
}
</script>
<style scoped>
.show{
    display: block;
}
</style>